import React from "react";
import HoverTooltip from "@Components/HoverTooltip";
export default class Warning extends React.Component {
    render() {
        return (React.createElement(HoverTooltip, { warning: true }, "This suppliers profit level may have a detrimental effect on service."));
    }
}
